import { VariantProps } from 'class-variance-authority'
import React from 'react'

import { toggleVariants } from '../Toggle'
import { ToggleGroup, ToggleGroupItem } from '../ToggleGroup'

// Helper to get enum values (works for string and numeric enums)
function getEnumValues<T extends object>(enumObj: T): string[] {
  const values = Object.values(enumObj)
  // Filter out reverse mappings for numeric enums
  return values.filter((v) => typeof v === 'string') as string[]
}

export interface ToggleGroupEnumProps<T extends object> {
  enumObject: T
  value: string
  onValueChange: (value: string) => void
  getLabel?: (value: string) => React.ReactNode
  className?: string
  variant?: VariantProps<typeof toggleVariants>['variant']
  size?: VariantProps<typeof toggleVariants>['size']
  [key: string]: unknown
}

function ToggleGroupEnum<T extends object>({
  enumObject,
  value,
  onValueChange,
  getLabel,
  className,
  variant,
  size,
  ...props
}: ToggleGroupEnumProps<T>) {
  const values = getEnumValues(enumObject)

  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={onValueChange}
      className={className}
      variant={variant}
      size={size}
      {...props}
    >
      {values.map((val) => (
        <ToggleGroupItem key={val} value={val}>
          {getLabel ? getLabel(val) : val}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}

export { ToggleGroupEnum }
export default ToggleGroupEnum
